type CaseCategory = 'diseno-identidad' | 'web-design' | 'estrategia-marca' | 'packaging';

const identModules = import.meta.glob('/src/assets/images/cases/diseno-identidad/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
const webModules = import.meta.glob('/src/assets/images/cases/web-design/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
const estrategiaModules = import.meta.glob('/src/assets/images/cases/estrategia-marca/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
const packagingModules = import.meta.glob('/src/assets/images/cases/packaging/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });
const generalModules = import.meta.glob('/src/assets/images/*.{png,jpg,jpeg,svg,webp,avif}', { eager: true });

function toItems(modules: Record<string, any>) {
  return Object.entries(modules).map(([path, mod]) => {
    const file = path.split('/').pop() || '';
    const name = file.replace(/\.[^.]+$/, '').replace(/[-_]/g, ' ');
    return { name, url: (mod as any).default as string };
  });
}

import meta from '../../data/cases.json';

export default function Cases() {
  const categories = [
    { key: 'diseno-identidad' as CaseCategory, title: 'Diseño e Identidad', color: '#9EFF00' },
    { key: 'web-design' as CaseCategory, title: 'Web Design', color: '#9EFF00' },
    { key: 'estrategia-marca' as CaseCategory, title: 'Estrategia de Marca', color: '#9EFF00' },
    { key: 'packaging' as CaseCategory, title: 'Packaging', color: '#9EFF00' },
  ];

  const data: Record<CaseCategory, { name: string; url: string }[]> = {
    'diseno-identidad': toItems({ ...identModules, ...generalModules }),
    'web-design': toItems(webModules),
    'estrategia-marca': toItems(estrategiaModules),
    'packaging': toItems(packagingModules),
  };

  return (
    <section id="casos" className="py-20 bg-[#0f0f23]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Casos de <span className="text-[#9EFF00]">Éxito</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Selección de proyectos en branding, web y estrategia realizados por nuestro equipo.
          </p>
        </div>

        {categories.map((cat) => (
          <div key={cat.key} className="mb-16">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-2xl md:text-3xl font-bold text-white">
                <span className={`text-[${cat.color}]`}>{cat.title}</span>
              </h3>
            </div>
            {(() => {
              const clean = (s: string) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-_]/g, ' ').trim();
              const items = data[cat.key];
              const metas = meta.cases.filter(c => c.category === cat.key);
              const grouped = metas.map(m => {
                const mt = clean(m.title);
                let imgs: string[] = [];
                if ((m as any).images && Array.isArray((m as any).images)) {
                  imgs = (m as any).images as string[];
                } else {
                  imgs = items.filter(i => {
                    const it = clean(i.name);
                    return it.includes(mt) || mt.includes(it) || it.startsWith(mt.split(' ')[0]);
                  }).map(i => i.url);
                }
                return { title: m.title, description: m.description || '', images: imgs };
              });

              const render = grouped;

              return render.length > 0 ? (
                <div className="grid grid-cols-1 gap-8">
                  {render.map(r => (
                    <div key={(r.images[0] || r.title)} className="overflow-hidden rounded-2xl bg-[#1a1a2e] border border-gray-800">
                      {r.images && r.images.length > 0 ? (
                        <img src={r.images[0]} alt={r.title} className="w-full h-[420px] object-cover" />
                      ) : (
                        <div className="w-full h-[420px] flex items-center justify-center text-gray-400">{r.title}</div>
                      )}
                      <div className="p-4">
                        <div className="text-white font-semibold">{r.title}</div>
                        {('description' in r && r.description) ? (
                          <div className="text-gray-300 text-sm mt-1">{(r as any).description}</div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-gray-400">Añade imágenes en <code className="text-gray-300">src/assets/images/cases/{cat.key}</code> para mostrar esta sección.</div>
              );
            })()}
          </div>
        ))}
      </div>
    </section>
  );
}